import request from "./request";

/**获取产品兑换列表 
 * @param {Number} uid
 * @param {String} usertoken
 * 
*/
export async function getInterList(uid = 0, usertoken = "", page = 1, limit = 10) {
  return await request.get(`/wxindex/jifenshop/index.html`, {
    params: {
      uid,
      usertoken,
      page,
      limit
    }
  })
}

/**提交兑换状态
 * @param {Object} postInfo
 * id,uid,usertoken
 * 
*/
export async function postInterSubmit(postInfo) {
  return await request.post(`/wxindex/jifenshop/book.html`, postInfo)
}

/**提交使用状态
 * @param {Object} postInfo
 * id,key,uid,usertoken
 * 
*/
export async function postVerificationSubmit(postInfo) {
  return await request.post(`/wxindex/jifenshop/check.html`, postInfo)
}